import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Apiservice from "../Apiservice";

const AllQuestions = () => {
    const { examId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const topicName = location.state?.topicName;
    const newQuestionId = location.state?.newQuestionId;
    const questionRefs = useRef({});
    const [allQuestion, setAllQuestion] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchQuestions();
    }, []);

    const fetchQuestions = async () => {
        const data = {
            exam_id: examId,
            status: 0,
        };
        const token = localStorage.getItem("access_token");

        // Define custom headers
        const headers = {
            access_token: token,
        };
        try {
            const result = await Apiservice.AllQuestionByExam(data, headers);
            if (result.success) {
                setAllQuestion(result.data);
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            console.error("Error fetching questions:", error);
            alert("An error occurred while fetching questions.");
        }
    };

    useEffect(() => {
        if (
            location.state?.newQuestionId &&
            questionRefs.current[location.state.newQuestionId]
        ) {
            questionRefs.current[
                location.state.newQuestionId
            ].scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    }, [allQuestion]);

    const handleEdit = (questionData) => {
        navigate(`/questionedit/${questionData.id}`);
    };

    const handleDelete = async (questionData) => {
        const data = {
            question_id: questionData.id,
            status: 0,
        };

        const userConfirmed = window.confirm(
            `Are you sure you want to delete the question: "${questionData.question}"?`
        );
        const token = localStorage.getItem("access_token");

        const headers = {
            access_token: token,
        };
        if (userConfirmed) {
            try {
                const result = await Apiservice.SoftDeleteQuestion(data, headers);

                if (result.success) {
                    alert("The question has been deleted successfully.");
                    setAllQuestion((prevQuestions) =>
                        prevQuestions.filter((q) => q.id !== questionData.id)
                    );
                } else {
                    alert(result.message || "Failed to delete the question.");
                }
            } catch (error) {
                console.error("Error during the delete operation:", error);
                alert("An error occurred while deleting the question.");
            }
        } else {
            alert("The delete operation has been canceled.");
        }
    };

    return (
        <div className="container-fluid p-0 p-md-3" style={{ backgroundColor: "white", userSelect: 'none' }}>
            {
                loading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                        <div className="text-center">
                            {/* Spinner with proper rotation */}
                            <div
                                className="spinner-border text-primary"
                                role="status"
                                style={{
                                    width: "2rem",
                                    height: "2rem",
                                    borderWidth: "3px",
                                }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            {/* Minimalist Text */}
                            <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                        </div>
                    </div>
                )
                    :
                    (
                        <>
                            <div
                                style={{
                                    position: "sticky",
                                    top: "0",
                                    zIndex: 1000,
                                    background: "white",
                                    paddingTop: "10px",
                                    paddingBottom: "10px",
                                }}
                            >
                                <div className="row mb-1">
                                    <div className="col text-center">
                                        <h4>All Questions</h4>
                                    </div>
                                </div>

                                <div className="row mb-1">
                                    <div className="col text-center">
                                        <h4>
                                            <u>{topicName}</u>
                                        </h4>
                                    </div>
                                </div>

                                <div className="row mb-3 justify-content-end">
                                    <div className="col-auto">
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={() => navigate(`/addquestion/${examId}`)}
                                        >
                                            Add Question
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <table className="table table-bordered table-striped">
                                        <thead className="table-active">
                                            <tr>
                                                <th style={{ width: "5%" }}>#</th>
                                                <th style={{ width: "75%" }}>Questions</th>
                                                <th style={{ width: "20%" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {allQuestion.length > 0 ? (
                                                allQuestion.map((questionData, index) => {
                                                    const parsedOptions = JSON.parse(questionData.options);

                                                    return (
                                                        <tr key={questionData.id}
                                                            ref={(el) => (questionRefs.current[questionData.id] = el)}>
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div className="mb-2">{questionData.question}</div>
                                                                <h6>Options:</h6>
                                                                {parsedOptions
                                                                    .slice(0, parsedOptions.length - 1)
                                                                    .map((option, idx) => (
                                                                        <div
                                                                            className="row align-items-center mb-1"
                                                                            key={idx}
                                                                        >
                                                                            <div className="col-auto">
                                                                                <input
                                                                                    type="radio"
                                                                                    className="btn-check"
                                                                                    name={`options-${index}`}
                                                                                    id={`option${idx + 1}-${index}`}
                                                                                    value={idx + 1}
                                                                                    checked={option.isCorrect}
                                                                                    readOnly
                                                                                />
                                                                                <label
                                                                                    className="btn btn-outline-secondary"
                                                                                    htmlFor={`option${idx + 1}-${index}`}
                                                                                >
                                                                                    {String.fromCharCode(97 + idx)}
                                                                                </label>
                                                                            </div>
                                                                            <div className="col">{option[`option${idx + 1}`]}</div>
                                                                        </div>
                                                                    ))}
                                                            </td>
                                                            <td>
                                                                <div className="d-grid gap-2">
                                                                    <button
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={() => handleEdit(questionData)}
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                    {/* <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(questionData)}
                                                    >
                                                        Delete
                                                    </button> */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={3} className="text-center">
                                                        No Questions Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    )
            }

        </div >
    );
};

export default AllQuestions;
